import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState, type ReactNode } from 'react'

import { GlobalDiceLoader } from '@/shared/components/GlobalDiceLoader'
import { isPrerendering } from '@/shared/lib/prerender'

const STALE_TIME_MS = 30_000
const GC_TIME_MS = 5 * 60_000

interface Props {
  children: ReactNode
}

export function QueryProvider({ children }: Props) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: STALE_TIME_MS,
            gcTime: GC_TIME_MS,
            retry: 1,
            refetchOnWindowFocus: false,
            // Prerender en build: sin datos (ver shared/lib/prerender). Las consultas con su
            // propio `enabled` lo sobrescriben, pero puppeteer además bloquea la API.
            enabled: !isPrerendering(),
          },
        },
      }),
  )

  return (
    <QueryClientProvider client={client}>
      {children}
      {/* Loader global "tirando los dados" — se mantiene aquí dentro del
          QueryClientProvider para tener acceso al QueryClient vía
          useIsFetching/useIsMutating. Aparece tras 400ms de operación en
          vuelo (mutations o initial loads). */}
      <GlobalDiceLoader />
    </QueryClientProvider>
  )
}
